// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"26":"b0bbb9af3624990389dc","645":"870f3fdcae6fdaac34f1"}[chunkId] + ".js";
};